import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { TemplateBrief } from '../../types/contractTemplate'
import TemplateRow from './TemplateRow'
import TemplateRowSkeleton from './TemplatesRow.skeleton'
import useStyles from './styles/TemplatesTable.styles'

interface TemplatesTableProps {
  loading: boolean
  data: TemplateBrief[]
  reloadData: () => void
  providerCode: string
}

export const TemplatesTable: React.FC<TemplatesTableProps> = ({
  loading,
  data,
  reloadData,
  providerCode
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map((item, index) => (
              <TemplateRowSkeleton
                key={`template-row-skeleton${index.toString()}`}
              />
            ))
        : data.map((singleContract) => (
            <TemplateRow
              key={singleContract.Id}
              data={singleContract}
              providerCode={providerCode}
            />
          ))}
    </div>
  )
}

export default TemplatesTable
